import { createContext, useContext, useState, useCallback, useRef, useEffect } from "react";

// Define all soundtracks - each world completion unlocks a new one
export const SOUNDTRACKS = {
  woody: {
    id: 'woody',
    name: 'Woody',
    description: 'The classic Fruit Crush melody',
    world: null, // Default, always unlocked
    emoji: '🎵',
    melody: [
      { freq: 523, dur: 0.2 },  // C5
      { freq: 587, dur: 0.2 },  // D5
      { freq: 659, dur: 0.2 },  // E5
      { freq: 523, dur: 0.2 },  // C5
      { freq: 698, dur: 0.3 },  // F5
      { freq: 659, dur: 0.2 },  // E5
      { freq: 587, dur: 0.2 },  // D5
      { freq: 523, dur: 0.4 },  // C5
      { freq: 784, dur: 0.2 },  // G5
      { freq: 698, dur: 0.2 },  // F5
      { freq: 659, dur: 0.2 },  // E5
      { freq: 587, dur: 0.2 },  // D5
      { freq: 523, dur: 0.3 },  // C5
      { freq: 392, dur: 0.2 },  // G4
      { freq: 440, dur: 0.2 },  // A4
      { freq: 523, dur: 0.5 },  // C5
    ],
    bass: [
      { freq: 131, dur: 0.4 },  // C3
      { freq: 131, dur: 0.4 },  // C3
      { freq: 175, dur: 0.4 },  // F3
      { freq: 175, dur: 0.4 },  // F3
      { freq: 196, dur: 0.4 },  // G3
      { freq: 196, dur: 0.4 },  // G3
      { freq: 131, dur: 0.4 },  // C3
      { freq: 131, dur: 0.4 },  // C3
    ],
    tempo: 430,
  },
  tropical_breeze: {
    id: 'tropical_breeze',
    name: 'Tropical Breeze',
    description: 'Unlock by completing Tropical Paradise',
    world: 1, // Tropical Paradise (levels 1-10)
    emoji: '🏝️',
    melody: [
      { freq: 440, dur: 0.3 },  // A4
      { freq: 523, dur: 0.2 },  // C5
      { freq: 659, dur: 0.3 },  // E5
      { freq: 587, dur: 0.2 },  // D5
      { freq: 523, dur: 0.2 },  // C5
      { freq: 440, dur: 0.4 },  // A4
      { freq: 392, dur: 0.2 },  // G4
      { freq: 440, dur: 0.3 },  // A4
      { freq: 523, dur: 0.2 },  // C5
      { freq: 587, dur: 0.3 },  // D5
      { freq: 659, dur: 0.2 },  // E5
      { freq: 784, dur: 0.4 },  // G5
      { freq: 659, dur: 0.2 },  // E5
      { freq: 523, dur: 0.3 },  // C5
      { freq: 440, dur: 0.5 },  // A4
    ],
    bass: [
      { freq: 110, dur: 0.4 },  // A2
      { freq: 147, dur: 0.4 },  // D3
      { freq: 165, dur: 0.4 },  // E3
      { freq: 110, dur: 0.4 },  // A2
      { freq: 131, dur: 0.4 },  // C3
      { freq: 147, dur: 0.4 },  // D3
      { freq: 110, dur: 0.4 },  // A2
      { freq: 165, dur: 0.4 },  // E3
    ],
    tempo: 400,
  },
  candy_dream: {
    id: 'candy_dream',
    name: 'Candy Dream',
    description: 'Unlock by completing Candy Kingdom',
    world: 2, // Candy Kingdom (levels 11-20)
    emoji: '🍬',
    melody: [
      { freq: 784, dur: 0.15 },  // G5
      { freq: 880, dur: 0.15 },  // A5
      { freq: 988, dur: 0.2 },   // B5
      { freq: 880, dur: 0.15 },  // A5
      { freq: 784, dur: 0.2 },   // G5
      { freq: 659, dur: 0.15 },  // E5
      { freq: 784, dur: 0.3 },   // G5
      { freq: 880, dur: 0.2 },   // A5
      { freq: 784, dur: 0.15 },  // G5
      { freq: 659, dur: 0.2 },   // E5
      { freq: 587, dur: 0.15 },  // D5
      { freq: 659, dur: 0.3 },   // E5
      { freq: 784, dur: 0.2 },   // G5
      { freq: 659, dur: 0.4 },   // E5
    ],
    bass: [
      { freq: 196, dur: 0.3 },  // G3
      { freq: 196, dur: 0.3 },  // G3
      { freq: 165, dur: 0.3 },  // E3
      { freq: 165, dur: 0.3 },  // E3
      { freq: 147, dur: 0.3 },  // D3
      { freq: 147, dur: 0.3 },  // D3
      { freq: 165, dur: 0.3 },  // E3
      { freq: 196, dur: 0.3 },  // G3
    ],
    tempo: 350,
  },
  forest_whisper: {
    id: 'forest_whisper',
    name: 'Forest Whisper',
    description: 'Unlock by completing Enchanted Forest',
    world: 3, // Enchanted Forest (levels 21-35)
    emoji: '🌲',
    melody: [
      { freq: 330, dur: 0.4 },  // E4
      { freq: 392, dur: 0.3 },  // G4
      { freq: 494, dur: 0.3 },  // B4
      { freq: 440, dur: 0.4 },  // A4
      { freq: 392, dur: 0.3 },  // G4
      { freq: 330, dur: 0.5 },  // E4
      { freq: 294, dur: 0.3 },  // D4
      { freq: 330, dur: 0.4 },  // E4
      { freq: 392, dur: 0.3 },  // G4
      { freq: 440, dur: 0.4 },  // A4
      { freq: 494, dur: 0.5 },  // B4
      { freq: 440, dur: 0.3 },  // A4
      { freq: 392, dur: 0.4 },  // G4
      { freq: 330, dur: 0.6 },  // E4
    ],
    bass: [
      { freq: 82, dur: 0.5 },   // E2
      { freq: 98, dur: 0.5 },   // G2
      { freq: 110, dur: 0.5 },  // A2
      { freq: 82, dur: 0.5 },   // E2
      { freq: 73, dur: 0.5 },   // D2
      { freq: 82, dur: 0.5 },   // E2
      { freq: 98, dur: 0.5 },   // G2
      { freq: 110, dur: 0.5 },  // A2
    ],
    tempo: 500,
  },
  ocean_depths: {
    id: 'ocean_depths',
    name: 'Ocean Depths',
    description: 'Unlock by completing Ocean Depths',
    world: 4, // Ocean Depths (levels 36-50)
    emoji: '🌊',
    melody: [
      { freq: 262, dur: 0.5 },  // C4
      { freq: 294, dur: 0.4 },  // D4
      { freq: 330, dur: 0.3 },  // E4
      { freq: 392, dur: 0.5 },  // G4
      { freq: 330, dur: 0.4 },  // E4
      { freq: 294, dur: 0.3 },  // D4
      { freq: 262, dur: 0.6 },  // C4
      { freq: 196, dur: 0.4 },  // G3
      { freq: 262, dur: 0.5 },  // C4
      { freq: 330, dur: 0.4 },  // E4
      { freq: 392, dur: 0.5 },  // G4
      { freq: 440, dur: 0.4 },  // A4
      { freq: 392, dur: 0.5 },  // G4
      { freq: 330, dur: 0.6 },  // E4
    ],
    bass: [
      { freq: 65, dur: 0.6 },   // C2
      { freq: 73, dur: 0.6 },   // D2
      { freq: 82, dur: 0.6 },   // E2
      { freq: 98, dur: 0.6 },   // G2
      { freq: 65, dur: 0.6 },   // C2
      { freq: 82, dur: 0.6 },   // E2
      { freq: 98, dur: 0.6 },   // G2
      { freq: 65, dur: 0.6 },   // C2
    ],
    tempo: 550,
  },
  crystal_cavern: {
    id: 'crystal_cavern',
    name: 'Crystal Cavern',
    description: 'Unlock by completing Crystal Caves',
    world: 5, // Crystal Caves (levels 51-70)
    emoji: '💎',
    melody: [
      { freq: 880, dur: 0.2 },  // A5
      { freq: 1047, dur: 0.2 }, // C6
      { freq: 988, dur: 0.3 },  // B5
      { freq: 880, dur: 0.2 },  // A5
      { freq: 784, dur: 0.3 },  // G5
      { freq: 880, dur: 0.2 },  // A5
      { freq: 1047, dur: 0.4 }, // C6
      { freq: 988, dur: 0.2 },  // B5
      { freq: 880, dur: 0.3 },  // A5
      { freq: 784, dur: 0.2 },  // G5
      { freq: 659, dur: 0.3 },  // E5
      { freq: 784, dur: 0.2 },  // G5
      { freq: 880, dur: 0.4 },  // A5
      { freq: 784, dur: 0.5 },  // G5
    ],
    bass: [
      { freq: 220, dur: 0.4 },  // A3
      { freq: 262, dur: 0.4 },  // C4
      { freq: 247, dur: 0.4 },  // B3
      { freq: 220, dur: 0.4 },  // A3
      { freq: 196, dur: 0.4 },  // G3
      { freq: 220, dur: 0.4 },  // A3
      { freq: 165, dur: 0.4 },  // E3
      { freq: 196, dur: 0.4 },  // G3
    ],
    tempo: 380,
  },
  volcano_fury: {
    id: 'volcano_fury',
    name: 'Volcano Fury',
    description: 'Unlock by completing Volcano Valley',
    world: 6, // Volcano Valley (levels 71-90)
    emoji: '🌋',
    melody: [
      { freq: 294, dur: 0.2 },  // D4
      { freq: 349, dur: 0.15 }, // F4
      { freq: 294, dur: 0.2 },  // D4
      { freq: 440, dur: 0.25 }, // A4
      { freq: 392, dur: 0.2 },  // G4
      { freq: 349, dur: 0.15 }, // F4
      { freq: 294, dur: 0.3 },  // D4
      { freq: 262, dur: 0.2 },  // C4
      { freq: 294, dur: 0.2 },  // D4
      { freq: 349, dur: 0.15 }, // F4
      { freq: 440, dur: 0.25 }, // A4
      { freq: 523, dur: 0.3 },  // C5
      { freq: 440, dur: 0.2 },  // A4
      { freq: 349, dur: 0.2 },  // F4
      { freq: 294, dur: 0.4 },  // D4
    ],
    bass: [
      { freq: 73, dur: 0.3 },   // D2
      { freq: 73, dur: 0.3 },   // D2
      { freq: 87, dur: 0.3 },   // F2
      { freq: 87, dur: 0.3 },   // F2
      { freq: 65, dur: 0.3 },   // C2
      { freq: 65, dur: 0.3 },   // C2
      { freq: 73, dur: 0.3 },   // D2
      { freq: 110, dur: 0.3 },  // A2
    ],
    tempo: 320,
  },
  sky_kingdom: {
    id: 'sky_kingdom',
    name: 'Sky Kingdom',
    description: 'Unlock by completing Sky Kingdom',
    world: 7, // Sky Kingdom (levels 91-110)
    emoji: '☁️',
    melody: [
      { freq: 659, dur: 0.3 },  // E5
      { freq: 784, dur: 0.3 },  // G5
      { freq: 880, dur: 0.4 },  // A5
      { freq: 784, dur: 0.3 },  // G5
      { freq: 659, dur: 0.4 },  // E5
      { freq: 587, dur: 0.3 },  // D5
      { freq: 523, dur: 0.4 },  // C5
      { freq: 587, dur: 0.3 },  // D5
      { freq: 659, dur: 0.4 },  // E5
      { freq: 784, dur: 0.3 },  // G5
      { freq: 880, dur: 0.5 },  // A5
      { freq: 1047, dur: 0.4 }, // C6
      { freq: 880, dur: 0.3 },  // A5
      { freq: 784, dur: 0.5 },  // G5
    ],
    bass: [
      { freq: 131, dur: 0.5 },  // C3
      { freq: 165, dur: 0.5 },  // E3
      { freq: 196, dur: 0.5 },  // G3
      { freq: 165, dur: 0.5 },  // E3
      { freq: 131, dur: 0.5 },  // C3
      { freq: 147, dur: 0.5 },  // D3
      { freq: 165, dur: 0.5 },  // E3
      { freq: 196, dur: 0.5 },  // G3
    ],
    tempo: 450,
  },
  ancient_mystery: {
    id: 'ancient_mystery',
    name: 'Ancient Mystery',
    description: 'Unlock by completing Ancient Ruins',
    world: 8, // Ancient Ruins (levels 111-130)
    emoji: '🏛️',
    melody: [
      { freq: 220, dur: 0.4 },  // A3
      { freq: 262, dur: 0.3 },  // C4
      { freq: 330, dur: 0.4 },  // E4
      { freq: 294, dur: 0.3 },  // D4
      { freq: 262, dur: 0.4 },  // C4
      { freq: 220, dur: 0.5 },  // A3
      { freq: 196, dur: 0.3 },  // G3
      { freq: 220, dur: 0.4 },  // A3
      { freq: 262, dur: 0.3 },  // C4
      { freq: 330, dur: 0.4 },  // E4
      { freq: 392, dur: 0.5 },  // G4
      { freq: 330, dur: 0.3 },  // E4
      { freq: 262, dur: 0.4 },  // C4
      { freq: 220, dur: 0.6 },  // A3
    ],
    bass: [
      { freq: 55, dur: 0.5 },   // A1
      { freq: 65, dur: 0.5 },   // C2
      { freq: 82, dur: 0.5 },   // E2
      { freq: 55, dur: 0.5 },   // A1
      { freq: 49, dur: 0.5 },   // G1
      { freq: 55, dur: 0.5 },   // A1
      { freq: 65, dur: 0.5 },   // C2
      { freq: 82, dur: 0.5 },   // E2
    ],
    tempo: 520,
  },
  dark_forest: {
    id: 'dark_forest',
    name: 'Dark Forest',
    description: 'Unlock by completing Dark Forest',
    world: 9, // Dark Forest (levels 131-150)
    emoji: '🌑',
    melody: [
      { freq: 196, dur: 0.4 },  // G3
      { freq: 233, dur: 0.3 },  // Bb3
      { freq: 262, dur: 0.4 },  // C4
      { freq: 233, dur: 0.3 },  // Bb3
      { freq: 196, dur: 0.5 },  // G3
      { freq: 175, dur: 0.3 },  // F3
      { freq: 165, dur: 0.4 },  // E3
      { freq: 175, dur: 0.3 },  // F3
      { freq: 196, dur: 0.4 },  // G3
      { freq: 233, dur: 0.5 },  // Bb3
      { freq: 262, dur: 0.3 },  // C4
      { freq: 294, dur: 0.4 },  // D4
      { freq: 262, dur: 0.3 },  // C4
      { freq: 196, dur: 0.6 },  // G3
    ],
    bass: [
      { freq: 49, dur: 0.5 },   // G1
      { freq: 58, dur: 0.5 },   // Bb1
      { freq: 65, dur: 0.5 },   // C2
      { freq: 49, dur: 0.5 },   // G1
      { freq: 44, dur: 0.5 },   // F1
      { freq: 41, dur: 0.5 },   // E1
      { freq: 44, dur: 0.5 },   // F1
      { freq: 49, dur: 0.5 },   // G1
    ],
    tempo: 550,
  },
  frozen_peaks: {
    id: 'frozen_peaks',
    name: 'Frozen Peaks',
    description: 'Unlock by completing Frozen Peaks',
    world: 10, // Frozen Peaks (levels 151-180)
    emoji: '❄️',
    melody: [
      { freq: 523, dur: 0.3 },  // C5
      { freq: 587, dur: 0.2 },  // D5
      { freq: 659, dur: 0.4 },  // E5
      { freq: 523, dur: 0.3 },  // C5
      { freq: 494, dur: 0.4 },  // B4
      { freq: 440, dur: 0.3 },  // A4
      { freq: 392, dur: 0.5 },  // G4
      { freq: 440, dur: 0.3 },  // A4
      { freq: 494, dur: 0.4 },  // B4
      { freq: 523, dur: 0.3 },  // C5
      { freq: 659, dur: 0.4 },  // E5
      { freq: 587, dur: 0.3 },  // D5
      { freq: 523, dur: 0.5 },  // C5
      { freq: 494, dur: 0.6 },  // B4
    ],
    bass: [
      { freq: 131, dur: 0.5 },  // C3
      { freq: 123, dur: 0.5 },  // B2
      { freq: 110, dur: 0.5 },  // A2
      { freq: 98, dur: 0.5 },   // G2
      { freq: 110, dur: 0.5 },  // A2
      { freq: 123, dur: 0.5 },  // B2
      { freq: 131, dur: 0.5 },  // C3
      { freq: 98, dur: 0.5 },   // G2
    ],
    tempo: 480,
  },
  cyber_city: {
    id: 'cyber_city',
    name: 'Cyber City',
    description: 'Unlock by completing Cyber City',
    world: 11, // Cyber City (levels 181-200)
    emoji: '🤖',
    melody: [
      { freq: 440, dur: 0.15 }, // A4
      { freq: 523, dur: 0.15 }, // C5
      { freq: 659, dur: 0.2 },  // E5
      { freq: 784, dur: 0.15 }, // G5
      { freq: 880, dur: 0.25 }, // A5
      { freq: 784, dur: 0.15 }, // G5
      { freq: 659, dur: 0.2 },  // E5
      { freq: 523, dur: 0.15 }, // C5
      { freq: 440, dur: 0.2 },  // A4
      { freq: 523, dur: 0.15 }, // C5
      { freq: 659, dur: 0.2 },  // E5
      { freq: 880, dur: 0.25 }, // A5
      { freq: 1047, dur: 0.2 }, // C6
      { freq: 880, dur: 0.15 }, // A5
      { freq: 659, dur: 0.3 },  // E5
    ],
    bass: [
      { freq: 110, dur: 0.25 }, // A2
      { freq: 110, dur: 0.25 }, // A2
      { freq: 131, dur: 0.25 }, // C3
      { freq: 131, dur: 0.25 }, // C3
      { freq: 165, dur: 0.25 }, // E3
      { freq: 165, dur: 0.25 }, // E3
      { freq: 110, dur: 0.25 }, // A2
      { freq: 131, dur: 0.25 }, // C3
    ],
    tempo: 300,
  },
  
  // ============== SPECIAL UNLOCKABLE SOUNDTRACKS ==============
  
  dawn: {
    id: 'dawn',
    name: 'Dawn',
    description: 'Peaceful ambient melody - Reach Level 50',
    world: null, // Special unlock at level 50
    unlockLevel: 50,
    emoji: '🌅',
    melody: [
      // Ethereal, ambient melody inspired by dawn breaking
      { freq: 392, dur: 0.6 },  // G4 - gentle start
      { freq: 440, dur: 0.5 },  // A4
      { freq: 494, dur: 0.7 },  // B4 - rising
      { freq: 523, dur: 0.6 },  // C5
      { freq: 587, dur: 0.8 },  // D5 - peak
      { freq: 523, dur: 0.5 },  // C5
      { freq: 494, dur: 0.6 },  // B4
      { freq: 440, dur: 0.7 },  // A4
      { freq: 392, dur: 0.8 },  // G4 - settle
      { freq: 349, dur: 0.6 },  // F4
      { freq: 392, dur: 0.7 },  // G4
      { freq: 440, dur: 0.9 },  // A4 - breathe
      { freq: 494, dur: 0.5 },  // B4
      { freq: 523, dur: 0.6 },  // C5
      { freq: 494, dur: 0.8 },  // B4 - fade
      { freq: 392, dur: 1.0 },  // G4 - rest
    ],
    bass: [
      // Soft, sustained bass notes
      { freq: 98, dur: 0.8 },   // G2
      { freq: 98, dur: 0.8 },   // G2
      { freq: 110, dur: 0.8 },  // A2
      { freq: 110, dur: 0.8 },  // A2
      { freq: 131, dur: 0.8 },  // C3
      { freq: 131, dur: 0.8 },  // C3
      { freq: 98, dur: 0.8 },   // G2
      { freq: 87, dur: 0.8 },   // F2
    ],
    tempo: 600, // Slower, more peaceful
  },
  
  dark_pulse: {
    id: 'dark_pulse',
    name: 'Dark Pulse',
    description: 'Heavy bass beats - Defeat 5 bosses',
    world: null, // Special unlock
    unlockCondition: 'bosses_defeated_5',
    emoji: '🖤',
    melody: [
      // Dark, minor key melody with tension
      { freq: 311, dur: 0.2 },  // Eb4
      { freq: 349, dur: 0.15 }, // F4
      { freq: 415, dur: 0.25 }, // Ab4
      { freq: 466, dur: 0.2 },  // Bb4
      { freq: 415, dur: 0.15 }, // Ab4
      { freq: 349, dur: 0.2 },  // F4
      { freq: 311, dur: 0.3 },  // Eb4
      { freq: 293, dur: 0.25 }, // D4
      { freq: 311, dur: 0.2 },  // Eb4
      { freq: 349, dur: 0.15 }, // F4
      { freq: 311, dur: 0.25 }, // Eb4
      { freq: 293, dur: 0.2 },  // D4
      { freq: 262, dur: 0.3 },  // C4
      { freq: 293, dur: 0.2 },  // D4
      { freq: 311, dur: 0.4 },  // Eb4 - resolve
    ],
    bass: [
      // Heavy, pulsing bass
      { freq: 62, dur: 0.2 },   // B1 - DEEP
      { freq: 62, dur: 0.2 },   // B1
      { freq: 73, dur: 0.2 },   // D2
      { freq: 62, dur: 0.2 },   // B1
      { freq: 78, dur: 0.2 },   // Eb2
      { freq: 78, dur: 0.2 },   // Eb2
      { freq: 62, dur: 0.2 },   // B1
      { freq: 55, dur: 0.2 },   // A1 - rumble
      { freq: 62, dur: 0.2 },   // B1
      { freq: 62, dur: 0.2 },   // B1
      { freq: 73, dur: 0.2 },   // D2
      { freq: 78, dur: 0.2 },   // Eb2
    ],
    tempo: 280, // Fast, aggressive
  },
  
  abyss: {
    id: 'abyss',
    name: 'Abyss',
    description: 'Deep underground bass - Reach Prestige 1',
    world: null, // Prestige unlock
    unlockCondition: 'prestige_1',
    emoji: '🕳️',
    melody: [
      // Ominous, descending melody
      { freq: 466, dur: 0.3 },  // Bb4
      { freq: 415, dur: 0.25 }, // Ab4
      { freq: 370, dur: 0.3 },  // F#4
      { freq: 349, dur: 0.35 }, // F4
      { freq: 311, dur: 0.3 },  // Eb4
      { freq: 293, dur: 0.25 }, // D4
      { freq: 262, dur: 0.4 },  // C4
      { freq: 233, dur: 0.3 },  // Bb3
      { freq: 262, dur: 0.25 }, // C4
      { freq: 293, dur: 0.3 },  // D4
      { freq: 311, dur: 0.35 }, // Eb4
      { freq: 293, dur: 0.25 }, // D4
      { freq: 262, dur: 0.4 },  // C4
      { freq: 233, dur: 0.5 },  // Bb3 - deep resolve
    ],
    bass: [
      // Extremely deep, rumbling bass
      { freq: 41, dur: 0.4 },   // E1 - VERY DEEP
      { freq: 41, dur: 0.4 },   // E1
      { freq: 49, dur: 0.4 },   // G1
      { freq: 41, dur: 0.4 },   // E1
      { freq: 55, dur: 0.4 },   // A1
      { freq: 49, dur: 0.4 },   // G1
      { freq: 41, dur: 0.4 },   // E1
      { freq: 37, dur: 0.4 },   // D1 - subwoofer territory
    ],
    tempo: 380, // Medium-slow, menacing
  },
  
  neon_shadow: {
    id: 'neon_shadow',
    name: 'Neon Shadow',
    description: 'Synthwave darkness - Collect 50,000 coins',
    world: null, // Currency unlock
    unlockCondition: 'coins_50000',
    emoji: '💜',
    melody: [
      // 80s synthwave style with minor key
      { freq: 330, dur: 0.15 }, // E4
      { freq: 392, dur: 0.15 }, // G4
      { freq: 440, dur: 0.2 },  // A4
      { freq: 523, dur: 0.15 }, // C5
      { freq: 494, dur: 0.2 },  // B4
      { freq: 440, dur: 0.15 }, // A4
      { freq: 392, dur: 0.2 },  // G4
      { freq: 330, dur: 0.25 }, // E4
      { freq: 294, dur: 0.15 }, // D4
      { freq: 330, dur: 0.2 },  // E4
      { freq: 392, dur: 0.15 }, // G4
      { freq: 440, dur: 0.2 },  // A4
      { freq: 523, dur: 0.25 }, // C5
      { freq: 494, dur: 0.15 }, // B4
      { freq: 392, dur: 0.2 },  // G4
      { freq: 330, dur: 0.3 },  // E4
    ],
    bass: [
      // Punchy synth bass
      { freq: 82, dur: 0.2 },   // E2
      { freq: 82, dur: 0.1 },   // E2 (staccato)
      { freq: 82, dur: 0.2 },   // E2
      { freq: 98, dur: 0.2 },   // G2
      { freq: 110, dur: 0.2 },  // A2
      { freq: 110, dur: 0.1 },  // A2 (staccato)
      { freq: 98, dur: 0.2 },   // G2
      { freq: 82, dur: 0.2 },   // E2
      { freq: 73, dur: 0.2 },   // D2
      { freq: 73, dur: 0.1 },   // D2 (staccato)
      { freq: 82, dur: 0.3 },   // E2
    ],
    tempo: 320, // Driving synthwave tempo
  },
  
  thunderstorm: {
    id: 'thunderstorm',
    name: 'Thunderstorm',
    description: 'Powerful storm bass - Win 25 perfect levels',
    world: null, // Achievement unlock
    unlockCondition: 'perfect_wins_25',
    emoji: '⛈️',
    melody: [
      // Dramatic, powerful melody
      { freq: 294, dur: 0.2 },  // D4
      { freq: 349, dur: 0.15 }, // F4
      { freq: 440, dur: 0.25 }, // A4
      { freq: 523, dur: 0.2 },  // C5
      { freq: 587, dur: 0.3 },  // D5 - thunder crack
      { freq: 523, dur: 0.15 }, // C5
      { freq: 440, dur: 0.2 },  // A4
      { freq: 349, dur: 0.25 }, // F4
      { freq: 294, dur: 0.3 },  // D4
      { freq: 262, dur: 0.2 },  // C4
      { freq: 294, dur: 0.15 }, // D4
      { freq: 349, dur: 0.25 }, // F4
      { freq: 392, dur: 0.2 },  // G4
      { freq: 440, dur: 0.3 },  // A4
      { freq: 349, dur: 0.4 },  // F4 - rumble away
    ],
    bass: [
      // Rolling thunder bass
      { freq: 73, dur: 0.25 },  // D2
      { freq: 55, dur: 0.25 },  // A1 (drop)
      { freq: 73, dur: 0.25 },  // D2
      { freq: 73, dur: 0.25 },  // D2
      { freq: 87, dur: 0.25 },  // F2
      { freq: 65, dur: 0.25 },  // C2 (drop)
      { freq: 73, dur: 0.25 },  // D2
      { freq: 55, dur: 0.25 },  // A1
      { freq: 49, dur: 0.3 },   // G1 - deep rumble
      { freq: 55, dur: 0.25 },  // A1
      { freq: 73, dur: 0.25 },  // D2
    ],
    tempo: 340, // Intense but not too fast
  },
};

// World to soundtrack mapping (last level of each world)
export const WORLD_LAST_LEVELS = {
  1: 10,   // Tropical Paradise
  2: 20,   // Candy Kingdom
  3: 35,   // Enchanted Forest
  4: 50,   // Ocean Depths
  5: 70,   // Crystal Caves
  6: 90,   // Volcano Valley
  7: 110,  // Sky Kingdom
  8: 130,  // Ancient Ruins
  9: 150,  // Dark Forest
  10: 180, // Frozen Peaks
  11: 200, // Cyber City
};

// Get soundtrack for a world number
export function getSoundtrackForWorld(worldNumber) {
  const soundtrackEntries = Object.values(SOUNDTRACKS);
  return soundtrackEntries.find(s => s.world === worldNumber);
}

// Check if a level is the last level of its world
export function isLastLevelOfWorld(levelId) {
  return Object.values(WORLD_LAST_LEVELS).includes(levelId);
}

// Get world number from level ID
export function getWorldFromLevel(levelId) {
  for (const [world, lastLevel] of Object.entries(WORLD_LAST_LEVELS)) {
    const prevWorldLastLevel = WORLD_LAST_LEVELS[parseInt(world) - 1] || 0;
    if (levelId > prevWorldLastLevel && levelId <= lastLevel) {
      return parseInt(world);
    }
  }
  return null;
}

// Soundtrack Context
const SoundtrackContext = createContext(null);

export function SoundtrackProvider({ children }) {
  const [unlockedSoundtracks, setUnlockedSoundtracks] = useState(['woody']);
  const [selectedSoundtrack, setSelectedSoundtrack] = useState('woody');
  const [loading, setLoading] = useState(true);
  
  const API_URL = process.env.REACT_APP_BACKEND_URL || '';
  const TOKEN_KEY = 'bananaBlast_auth_token';

  // Fetch soundtracks from backend - with sync to retroactively award based on completed levels
  const fetchSoundtracks = useCallback(async () => {
    const token = localStorage.getItem(TOKEN_KEY);
    if (!token) {
      setLoading(false);
      return;
    }

    try {
      // First sync soundtracks (awards soundtracks for already completed worlds)
      await fetch(`${API_URL}/api/soundtracks/sync`, {
        method: 'POST',
        headers: { 
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });
      
      // Then fetch from progress (which now includes soundtrack data)
      const response = await fetch(`${API_URL}/api/progress`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      
      if (response.ok) {
        const data = await response.json();
        const unlocked = data.unlocked_soundtracks || ['woody'];
        const selected = data.selected_soundtrack || 'woody';
        console.log('[Soundtracks] Loaded:', unlocked.length, 'unlocked, selected:', selected);
        setUnlockedSoundtracks(unlocked);
        setSelectedSoundtrack(selected);
      }
    } catch (error) {
      console.error('Failed to fetch soundtracks:', error);
    } finally {
      setLoading(false);
    }
  }, [API_URL]);

  // Select a soundtrack
  const selectSoundtrack = useCallback(async (soundtrackId) => {
    if (!unlockedSoundtracks.includes(soundtrackId)) {
      console.warn('Soundtrack not unlocked:', soundtrackId);
      return false;
    }

    const token = localStorage.getItem(TOKEN_KEY);
    if (!token) return false;

    try {
      const response = await fetch(`${API_URL}/api/soundtracks/select`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({ soundtrack_id: soundtrackId })
      });

      if (response.ok) {
        setSelectedSoundtrack(soundtrackId);
        localStorage.setItem('bananaBlast_selectedSoundtrack', soundtrackId);
        return true;
      }
    } catch (error) {
      console.error('Failed to select soundtrack:', error);
    }
    return false;
  }, [API_URL, unlockedSoundtracks]);

  // Unlock a soundtrack
  const unlockSoundtrack = useCallback(async (soundtrackId) => {
    if (unlockedSoundtracks.includes(soundtrackId)) {
      return true; // Already unlocked
    }

    const token = localStorage.getItem(TOKEN_KEY);
    if (!token) return false;

    try {
      const response = await fetch(`${API_URL}/api/soundtracks/unlock`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({ soundtrack_id: soundtrackId })
      });

      if (response.ok) {
        setUnlockedSoundtracks(prev => [...prev, soundtrackId]);
        return true;
      }
    } catch (error) {
      console.error('Failed to unlock soundtrack:', error);
    }
    return false;
  }, [API_URL, unlockedSoundtracks]);

  // Load on mount
  useEffect(() => {
    fetchSoundtracks();
  }, [fetchSoundtracks]);

  // Get current soundtrack config
  const currentSoundtrack = SOUNDTRACKS[selectedSoundtrack] || SOUNDTRACKS.woody;

  const value = {
    unlockedSoundtracks,
    selectedSoundtrack,
    currentSoundtrack,
    loading,
    selectSoundtrack,
    unlockSoundtrack,
    fetchSoundtracks,
    SOUNDTRACKS,
  };

  return (
    <SoundtrackContext.Provider value={value}>
      {children}
    </SoundtrackContext.Provider>
  );
}

export function useSoundtracks() {
  const context = useContext(SoundtrackContext);
  if (!context) {
    return {
      unlockedSoundtracks: ['woody'],
      selectedSoundtrack: 'woody',
      currentSoundtrack: SOUNDTRACKS.woody,
      loading: false,
      selectSoundtrack: () => false,
      unlockSoundtrack: () => false,
      fetchSoundtracks: () => {},
      SOUNDTRACKS,
    };
  }
  return context;
}
